var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "0.002 0 470.277 120.69",
    viewBox: "0.002 0 470.277 120.69",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-knd83qfa svg [data-color=\"1\"] {fill: #04283B;}\n#comp-knd83qfa svg [data-color=\"2\"] {fill: #E65235;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "393c4da4-5702-46d2-9b47-9d2a15da09b6_comp-knd83qfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.28 0v120.76H0V0h470.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#393c4da4-5702-46d2-9b47-9d2a15da09b6_comp-knd83qfa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.8 36.26a20 20 0 0 0-14.91 6.64l-2.54-5.58h-9.15v45.19h11.66v-30.3c2.81-3.73 7-6.12 11.14-6.12 5.43 0 11.8 3.37 11.8 9.39v27h11.68V54.07c0-11.61-9.9-17.81-19.68-17.81",
    fill: "#04283b",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 36.27c-5.75 0-12.16 2.66-15.53 6.64v-25.3h-1.15L424 22.6v59.92h11.43v-30.3c2.75-3.72 6.82-6.12 10.9-6.12 5.31 0 12.52 3.37 12.52 9.4v27h11.43V54.08c0-11.61-9.74-17.81-19.32-17.81",
    fill: "#04283b",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.38 22.56v19.25a21.27 21.27 0 0 0-14.62-5.58c-12.05 0-22.16 9.12-22.16 23.65s10.11 23.66 22.16 23.66A21.27 21.27 0 0 0 352.38 78l1.74 4.52h9.78V17.57h-1.24Zm0 46.36a18.42 18.42 0 0 1-12.14 5C333.15 74 327 68.66 327 59.88c.09-8.77 6.2-14.08 13.29-14.08a18.42 18.42 0 0 1 12.14 5.05Z",
    fill: "#04283b",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.18 37.32 240 42.08a20.47 20.47 0 0 0-14.83-5.82c-12.05 0-22.15 9.12-22.15 23.65s10.1 23.66 22.15 23.66A21.25 21.25 0 0 0 239.8 78l1.75 4.52h9.77v-45.2ZM239.8 69a18.4 18.4 0 0 1-12.14 5c-7.08 0-13.2-5.31-13.29-14.09.09-8.77 6.21-14.08 13.29-14.08a18.4 18.4 0 0 1 12.14 5.05Z",
    fill: "#04283b",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.88 36c-13 0-22.86 8.68-22.86 23.3 0 13.64 8.68 24 24 24 6.38 0 13.38-1.77 17.1-3.81l-4.31-7.73a37.48 37.48 0 0 1-11.46 2c-7.79 0-13.17-3.91-14.41-11.51h32.76c.08-1.5.17-3.38.18-3.67.12-13.12-7.45-22.58-21-22.58m-11.52 18.14A11.43 11.43 0 0 1 394.88 45c5.85 0 9.48 3.46 10.28 9.13Z",
    fill: "#04283b",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.48 67.21c-2.75 3.72-6.82 6.11-10.9 6.11-5.31 0-12.52-3.37-12.52-9.39V37.32h-11.44v28.44c0 11.61 10.67 17.81 20.24 17.81h.06c6.32 0 11-1.68 14.44-4.87-.83 6-4.31 10.08-9.62 11.7a25.12 25.12 0 0 1-5.63.78 43.49 43.49 0 0 1-8.22-.86V101a50.06 50.06 0 0 0 9.21.94c15.41 0 25.72-9.86 25.81-25.19V37.32h-11.43Z",
    fill: "#04283b",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7 31.23h-7.52a3.76 3.76 0 0 1-3.76-3.76V3.76A3.76 3.76 0 0 1 50.18 0h7.52a3.75 3.75 0 0 1 3.75 3.76v23.71a3.75 3.75 0 0 1-3.75 3.76",
    fill: "#f65409",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74 96.82.62 90.54a3.77 3.77 0 0 1 1.07-5.21L23.54 71a3.77 3.77 0 0 1 5.2 1.08l4.12 6.28a3.76 3.76 0 0 1-1.08 5.21L9.94 97.9a3.77 3.77 0 0 1-5.2-1.08",
    fill: "#f65409",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.35 30.17-4.11-6.29A3.76 3.76 0 0 0 98 22.79L56 50.3a3.76 3.76 0 0 1-4.12 0L9.94 22.8a3.77 3.77 0 0 0-5.2 1.08L.62 30.17a3.75 3.75 0 0 0 1.08 5.2l43 28.21a3.79 3.79 0 0 1 1.7 3.14l.08 50.22a3.74 3.74 0 0 0 3.76 3.75h7.51a3.75 3.75 0 0 0 3.75-3.76l-.08-50.19a3.76 3.76 0 0 1 1.7-3.15l43.15-28.21a3.76 3.76 0 0 0 1.09-5.2",
    fill: "#f65409",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.22 72.07-4.12 6.28a3.76 3.76 0 0 0 1.08 5.21L98 97.9a3.76 3.76 0 0 0 5.2-1.08l4.13-6.28a3.78 3.78 0 0 0-1.08-5.21L84.43 71a3.78 3.78 0 0 0-5.21 1.08",
    fill: "#f65409",
    "data-color": 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.747b196d416381b1924936fbca70255d.svg";
export { ForwardRef as ReactComponent };